import React, {Component} from 'react'
import {
    Select,
    MenuItem,
    CircularProgress,
    Container,
    FormControl,
    FormHelperText,
    TextField,
    Checkbox,
    Modal,
    Fade,
    FormControlLabel,
    Snackbar,
    Button
} from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import {DatePicker} from '@material-ui/pickers';
import http from '../app/http'
import format from "date-fns/format";
import ruLocale from "date-fns/locale/ru";
import MaterialUiPhoneNumber from "material-ui-phone-number";
import {BookingNotAvailable} from "./booking/not-available";
import {BookingMetrica} from "./metrika/booking";
import Cookies from "js-cookie";
import {zonedTimeToUtc} from "date-fns-tz";
import isSameDay from "date-fns/isSameDay";
import isPast from "date-fns/isPast";
import isToday from "date-fns/isToday";
import {action} from "mobx";
import {SmsModal} from "./shared/sms_modal";


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const styles = {
    loader: {
        margin: 'auto'
    },
    buttonLoader: {
        width: '1.5em',
        height: '1.5em',
    },
    studioTitle: {
        fontSize: '1.5em',
        fontWeight: '500',
        marginTop: '40px',
        marginBottom: '10px'
    },
    roomTitle: {
        fontSize: '0.9em',
        marginBottom: '28px'
    },
    info: {
        fontWeight: '500',
        marginBottom: '1em',
    },
    inputGrey: {
        backgroundColor: '#EEECEC',
        borderRadius: '4px',
    },
    container: {
        color: '#4a4a4a',
        display: 'flex',
        justifyContent: 'center'
    },
    flexFullWidth: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
    },
    marginTop: {
        marginTop: '2.5em'
    },
    marginTopMin: {
        marginTop: '2.2em'
    },
    leftSmall: {
        width: '50%'
    },
    selectLeft: {
        width: '50%',
        paddingRight: '20px'
    },
    selectRight: {
        width: '50%',
        paddingLeft: '20px'
    },
    fullWidth: {
        width: '100%'
    },
    tskyLogo: {
        width: '3.5em',
        marginTop: '40px',
    },
    from_element: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    load_bar: {
        marginBottom: '-5em',
        height: '5em',
        zIndex: 1000,
    },
    hot_image: {
        width: '1.5em'
    },
    schedule_list: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    one_schedule: {
        backgroundColor: '#fff',
        marginBottom: '1rem',
        borderRadius: '3px',
        cursor: 'pointer',
        boxShadow: 'rgb(204, 204, 204) 0px 0px 4px',
        display: 'flex',
        width: 'max-content',
        padding: '0.5rem 0.8rem',
        fontSize: '0.8em',
        marginRight: '0.8em',
    },
    one_schedule_active: {
        marginBottom: '1rem',
        borderRadius: '3px',
        cursor: 'pointer',
        boxShadow: 'rgb(204, 204, 204) 0px 0px 1px',
        display: 'flex',
        width: 'max-content',
        padding: '0.5rem 0.8rem',
        fontSize: '0.8em',
        marginRight: '0.8em',
        backgroundColor: '#aacdf3 ',
    },
};

class Slots extends Component {
    constructor() {
        super();
        this.state = {
            currentDate: new Date(),
            selectedDate: new Date(),
            checkedDate: new Date(),
            loading: false,
            requestSend: false,
            loadingFirst: true,
            openAlert: false,
            rules_check: true,
            show_sms_code_modal: false,
            openModal: false,
            has_google_sync: false,
            alertMessage: '',
            alertMessageType: 'success',
            roomId: null,
            scheduleId: null,
            sms_code: '',
            schedules: [],
            blockedDates: [],
            price: null,
            banner: null,
            hot_offer: null,
            resPrice: 0,
            discount: 0,
            phone: '',
            user_name: '',
            bookingServiceType: 'app',
            bookingRules: '',
            buttonDisabled: true,
            resSlotSize: 0,
            room: {
                name: null,
                studio: null,
            },
            times: {
                from: [],
                to: []
            },
            selectedFrom: 0,
            selectedFromIndex: null,
            selectedTo: 0,
            selectedToIndex: null,
        }
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let roomId = urlParams.get('roomId');
        if (!roomId) {
            const regRes = window.location.pathname.match(/\/booking\/(.*)/);
            if (regRes.length > 1) {
                roomId = regRes[1];
            }
        }
        Promise.resolve()
            .then(() => this.setState({
                ...this.state,
                selectedDate: urlParams.get('date') ? new Date(urlParams.get('date')) : new Date(),
                checkedDate: this.state.checkedDate.setDate(this.state.checkedDate.getDate() - 1),
                roomId: roomId
            }))
            .then(this.getAuthFromApp)
            .then(() => this.getSlots())
    }

    getAuthFromApp = () => {
        let cookieToken = Cookies.get('AuthToken');
        let localToken = localStorage.getItem('token')
        if (cookieToken && !(localToken !== undefined && localToken !== 'undefined' && localToken !== null)) {
            localStorage.setItem('token', cookieToken);
        }
    }

    handleDateChange = (date) => {
        Promise.resolve()
            .then(() => this.setState({
                ...this.state,
                selectedDate: date,
                loading: true,
            }))
            .then(() => this.getSlots())
    };

    handleChangeSchedule = (id) => {
        if (id !== this.state.scheduleId) {
            Promise.resolve()
                .then(() => this.setState({
                    ...this.state,
                    scheduleId: id,
                    loading: true,
                }))
                .then(() => this.getSlots())
        }
    };

    changeFrom = ({target}) => {
        let disabled = false;
        Promise.resolve()
            .then(() =>
                target.value !== 0 ?
                    this.state.times.from.forEach((el, key) => {
                        if (target.value === el.time) {
                            this.setState({...this.state, selectedFromIndex: key});
                        }
                    })
                    : this.setState({...this.state, selectedFromIndex: null})
            )
            .then(() => this.state.times.to.forEach((el, key) => {
                el.disabled = key < this.state.selectedFromIndex || disabled;
                if (key >= this.state.selectedFromIndex && el.busy) {
                    disabled = true;
                }
            }))
            .then(() => this.setState({...this.state, selectedFrom: target.value}))
            .then(() => this.setState({...this.state, selectedTo: 0, selectedToIndex: null}))
            .then(this.updatePrice)
            .then(this.calcDisable);
    };

    changeTo = ({target}) => {
        Promise.resolve()
            .then(() => this.setState({...this.state, selectedTo: target.value}))
            .then(() =>
                target.value !== 0 ?
                    this.state.times.to.forEach((el, key) => {
                        if (target.value === el.time) {
                            this.setState({...this.state, selectedToIndex: key});
                        }
                    })
                    : this.setState({...this.state, selectedToIndex: null})
            )
            .then(this.updatePrice)
            .then(this.calcDisable);
    };

    handleOnChange = (key, value) => {
        if (key === 'rules_check') {
            value = !this.state.rules_check;
        } else {
            value = (key === 'user_name' || key === 'sms_code') ? value.target.value : value;
        }
        Promise.resolve()
            .then(() => this.setState({...this.state, [key]: value}))
            .then(this.calcDisable);

    };

    handleModal = () => {
        this.setState({
            ...this.state,
            openModal: !this.state.openModal,
            rules_check: this.state.openModal ? this.state.rules_check : !this.state.rules_check,
        })
    };

    calcDisable = () => {
        if (this.state.phone.replace(/\+|\(|\)|-| /g, '').length === 11 && this.state.user_name && this.state.resSlotSize && this.state.resPrice && this.state.rules_check) {
            this.setState({...this.state, buttonDisabled: false})
        } else {
            this.setState({...this.state, buttonDisabled: true})
        }
    };


    updatePrice = () => {
        let discount = 0, price = 0, resSrice = 0, resSlotSize = 0;
        return Promise.resolve()
            .then(() => {
                if (this.state.selectedToIndex !== null && this.state.selectedFromIndex !== null) {
                    for (let i = this.state.selectedFromIndex; i <= this.state.selectedToIndex; i++) {
                        discount += this.state.times.from[i].discount_sum;
                        resSrice += parseInt(this.state.times.from[i].price);
                        resSlotSize += parseInt(this.state.times.from[i].slot_size);
                        if (price === 0) {
                            price = this.state.times.from[i].price;
                        }
                        if (price && price !== this.state.times.from[i].price) {
                            price = null;
                        }
                    }
                }
            })
            .then(() => {
                this.setState({
                    ...this.state,
                    resPrice: resSrice,
                    price: price,
                    resSlotSize: resSlotSize,
                    discount: discount
                })

            });

    };

    handleClose = () => {
        this.setState({
            ...this.state,
            openAlert: false,
        });
    }

    getSlots = () => {
        http.get(`/appointments/get-slots?id=${this.state.roomId}&schedule_id=${this.state.scheduleId}&date=${this.state.selectedDate.getTime()}&serviceType=${this.state.bookingServiceType}`)
            .then(({data}) => {
                this.setState({...this.state, ...data.content});
            })
            .then(() => this.setState({
                ...this.state,
                loadingFirst: false,
                loading: false,
                buttonDisabled: true,
                selectedToIndex: null,
                selectedFromIndex: null,
                selectedTo: 0,
                selectedFrom: 0
            }))
            .then(this.updatePrice)
    };

    @action
    setOrderCallback = () => {
        Promise.resolve()
            .then(() => {
                this.setState({
                    buttonDisabled: true,
                    requestSend: true
                })
                if (this.state.sms_required && (!this.state.sms_code || this.state.sms_code.length !== 4)) {
                    http
                        .post(`/appointments/send-sms`, {
                            roomId: this.state.roomId,
                            phone: this.state.phone,
                        })
                        .then(() => {
                            this.setState({
                                show_sms_code_modal: true,
                                sms_code: ''
                            })
                        })
                } else {
                    this.setOrder()
                }
            })
    }
    setOrder = () => {
        Promise.resolve()
            .then(() =>
                this.setState({
                    buttonDisabled: true,
                    requestSend: true
                }))
            .then(() => {
                http.post(`/appointments/order`, {
                    roomId: this.state.roomId,
                    serviceType: this.state.bookingServiceType,
                    scheduleId: this.state.scheduleId,
                    sms_code: this.state.sms_code,
                    date: this.state.selectedDate.getTime(),
                    phone: this.state.phone,
                    user_name: this.state.user_name,
                    timeFrom: this.state.selectedFrom,
                    timeTo: this.state.selectedTo,
                    price: this.state.resPrice - this.state.discount,
                })
                    .then(({data}) => {
                        this.setState({
                            ...this.state,
                            openAlert: true,
                            show_sms_code_modal: false,
                            sms_code: '',
                            alertMessage: data.content.message,
                            alertMessageType: 'success',
                            requestSend: false
                        });
                    })
                    .then(() => this.getSlots())
                    .catch(({response}) => {
                        let alertMessage = 'Что-то пошло не так :(';
                        if (response && response.data && response.data.message) {
                            alertMessage = response.data.message
                        }
                        this.setState({
                            ...this.state,
                            openAlert: true,
                            alertMessage: alertMessage,
                            alertMessageType: 'error',
                            requestSend: false
                        })
                    })
            });
    };

    disableDates = (date) => {
        let busyDay = false;
        date = zonedTimeToUtc(date, 'Europe/Moscow');

        if (this.state.blockedDates.length > 0) {
            this.state.blockedDates.forEach(value => {
                    if (isSameDay(date, value)) {
                        busyDay = true;
                    }
                }
            )
        }
        return (isPast(date) || busyDay) && !isToday(date);
    };

    render() {
        return (
            <Container style={styles.container} className="slots-root">
                {
                    process.env.NODE_ENV !== 'development' ?
                        <BookingMetrica/>
                        : ''
                }
                {this.state.loadingFirst ?
                    <CircularProgress color="secondary" style={styles.loader}/> :
                    <div>
                        {this.state.room.booking_enabled ?
                            <div className="booking">
                                <div className="room-info">
                                    <div className="room-poster">
                                        <img alt="poster" className="room-poster-image" style={{width: '100%'}}
                                             src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.ru/' : '') + this.state.room.poster}/>
                                    </div>
                                    <h3 className="room-title full-width">
                                        {this.state.room.name}
                                    </h3>
                                    <div className="room-description">
                                        {this.state.room.description}
                                    </div>
                                </div>
                                <div className="slots">
                                    <div className="studio-title">
                                        <div>
                                            <div style={styles.studioTitle}>{this.state.room.studio}</div>
                                            <div style={styles.roomTitle}>{this.state.room.name}</div>
                                        </div>
                                        <div>
                                            <img alt="logo-booking" style={styles.tskyLogo}
                                                 src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/logo_booking.png'}/>
                                        </div>
                                    </div>
                                    {
                                        this.state.banner ?
                                            <div className="booking-banner">
                                                <a href={this.state.banner.target_url} target="_blank"
                                                   rel="noopener noreferrer">
                                                    <img
                                                        src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + this.state.banner.image_url}
                                                        alt="banner"/>
                                                </a>
                                            </div>
                                            : ''
                                    }
                                    {
                                        this.state.schedules.length > 1 ?
                                            <div style={styles.schedule_list}>
                                                {this.state.schedules.map((el, key) =>
                                                    <div onClick={this.handleChangeSchedule.bind(this, el.id)}
                                                         style={this.state.scheduleId === el.id ? styles.one_schedule_active : styles.one_schedule}
                                                         key={key}>
                                                        {el.title}
                                                    </div>
                                                )}
                                            </div>
                                            : ''
                                    }
                                    <br/>
                                    {this.state.hot_offer ?
                                        <div className="booking-hot-banner">
                                            <div className="booking-hot-banner-title">Успей взять!</div>
                                            <div className="booking-hot-banner-content">{this.state.hot_offer.text}</div>
                                        </div>
                                        : ''}
                                    <DatePicker
                                        shouldDisableDate={this.disableDates}
                                        label="Выберите дату"
                                        value={this.state.selectedDate}
                                        onChange={this.handleDateChange}
                                        style={styles.fullWidth}
                                        format={"d MMMM yyyy"}
                                        className="calendar-clicker"
                                        animateYearScrolling
                                        disablePast
                                    />
                                    {this.state.loading ?
                                        <div style={{...styles.flexFullWidth, ...styles.load_bar}}>
                                            <CircularProgress color="secondary" style={styles.loader}/>
                                        </div> : ''}
                                    <div style={styles.flexFullWidth}>
                                        <FormControl style={styles.selectLeft}>
                                            <FormHelperText>Время начала</FormHelperText>
                                            <Select onChange={this.changeFrom} value={this.state.selectedFrom}
                                                    disabled={this.state.loading}>
                                                <MenuItem value={0}>Не выбрано</MenuItem>
                                                {this.state.times.from.map((el, key) =>
                                                    <MenuItem disabled={el.busy || el.disabled} value={el.time}
                                                              style={styles.from_element}
                                                              key={key}>
                                                        {el.time}
                                                        {el.discount_sum ?
                                                            <img alt="hot-pepper" style={styles.hot_image}
                                                                 src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/hot.png'}/>
                                                            : ''
                                                        }
                                                    </MenuItem>)}
                                            </Select>
                                        </FormControl>
                                        <FormControl style={styles.selectRight}>
                                            <FormHelperText>Время окончания</FormHelperText>
                                            <Select onChange={this.changeTo} value={this.state.selectedTo}
                                                    disabled={this.state.loading}>
                                                <MenuItem value={0}>Не выбрано</MenuItem>
                                                {this.state.times.to.map((el, key) =>
                                                    <MenuItem disabled={el.busy || el.disabled}
                                                              key={key}
                                                              style={styles.from_element}
                                                              value={el.time}>
                                                        {el.time}
                                                        {el.discount_sum ?
                                                            <img alt="hot-pepper" style={styles.hot_image}
                                                                 src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/hot.png'}/>
                                                            : ''
                                                        }
                                                    </MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {this.state.resSlotSize && this.state.resPrice ?
                                        <div className="booking-slot-result">
                                            <div style={styles.info}>Информация по заказу:</div>
                                            <div style={{
                                                ...styles.flexFullWidth,
                                                fontSize: '0.9em'
                                            }}>
                                                <div
                                                    style={styles.leftSmall}>{format(this.state.selectedDate, "eeeeee, d MMMM", {locale: ruLocale}).replace(/./, m => m.toUpperCase())}</div>
                                                {/*<div>{this.state.resSlotSize} ч.</div>*/}
                                            </div>
                                            <div style={{
                                                ...styles.flexFullWidth,
                                                fontSize: '0.9em'
                                            }}>
                                                <div
                                                    style={styles.leftSmall}>Время
                                                </div>
                                                <div>{this.state.selectedFrom} — {this.state.selectedTo}</div>
                                            </div>
                                            <div style={{
                                                ...styles.flexFullWidth,
                                                marginTop: '1.5em',
                                            }}/>
                                            {this.state.price > 0 ?
                                                <div style={{
                                                    ...styles.flexFullWidth,
                                                    fontSize: '0.9em'
                                                }}>
                                                    <div style={styles.leftSmall}>Стоимость</div>
                                                    <div>{this.state.resPrice}р.</div>
                                                </div>
                                                : ''}
                                            {this.state.discount > 0 ?
                                                <div style={{
                                                    ...styles.flexFullWidth,
                                                    fontSize: '0.9em'
                                                }}>
                                                    <div style={styles.leftSmall}>Скидка</div>
                                                    <div>{this.state.discount}р.</div>
                                                </div>
                                                : ''
                                            }
                                            <div style={{
                                                ...styles.flexFullWidth, fontSize: '1.3em',
                                                marginTop: '1.4em'
                                            }}>
                                                <div style={styles.leftSmall}>Итого</div>
                                                <div>{this.state.resPrice - this.state.discount}р.</div>
                                            </div>
                                        </div>
                                        : ''}

                                    <FormControl
                                        style={{...styles.flexFullWidth, ...styles.inputGrey, marginTop: '1.5em'}}
                                        className="hide-border"
                                    >
                                        <TextField
                                            placeholder="Ваше имя"
                                            onChange={this.handleOnChange.bind(this, 'user_name')}
                                            value={this.state.user_name}
                                            variant="outlined"
                                        />
                                    </FormControl>
                                    <FormControl
                                        style={{...styles.flexFullWidth, ...styles.inputGrey, marginTop: '1.5em'}}
                                        className="hide-border"
                                    >
                                        <MaterialUiPhoneNumber
                                            placeholder="Номер телефона"
                                            defaultCountry={'ru'}
                                            variant="outlined"
                                            onChange={this.handleOnChange.bind(this, 'phone')}
                                            value={this.state.phone}
                                        />
                                    </FormControl>
                                    <Button variant="contained"
                                            onClick={this.setOrderCallback}
                                            disabled={this.state.buttonDisabled || this.state.loading} color="secondary"
                                            style={{
                                                width: '100%',
                                                marginTop: '2.5em',
                                                borderRadius: '8px',
                                                height: '4em',
                                                backgroundColor: this.state.buttonDisabled ? '' : '#ee6a62',
                                            }}
                                    >
                                        {
                                            this.state.requestSend ?
                                                <CircularProgress color="secondary" style={styles.buttonLoader}/>
                                                :
                                                this.state.has_google_sync ? 'Забронировать' : 'Отправить запрос'
                                        }

                                    </Button>
                                    <FormControl style={{...styles.flexFullWidth, marginTop: '1.5em'}}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.rules_check}
                                                    onChange={this.handleOnChange.bind(this, 'rules_check')}
                                                    value="primary"
                                                    inputProps={{'aria-label': 'primary checkbox'}}
                                                />
                                            }
                                            label={<span>Я согласен(а) с {this.state.bookingRules ?
                                                <span onClick={this.handleModal}
                                                      style={{
                                                          color: 'rgb(238, 106, 98)',
                                                          textDecoration: 'underline'
                                                      }}>правилами</span> : 'правилами'} студии</span>}
                                        />
                                    </FormControl>
                                    <Snackbar open={this.state.openAlert} autoHideDuration={60000}
                                              onClose={this.handleClose}>
                                        <Alert severity={this.state.alertMessageType} onClose={this.handleClose}>
                                            {this.state.alertMessage}
                                        </Alert>
                                    </Snackbar>
                                    <SmsModal
                                        visible={this.state.show_sms_code_modal}
                                        smsCode={this.state.sms_code}
                                        onSubmitHandler={this.setOrderCallback}
                                        handleChangeCode={this.handleOnChange.bind(this, 'sms_code')}
                                    />
                                    <Modal
                                        aria-labelledby="spring-modal-title"
                                        aria-describedby="spring-modal-description"
                                        open={this.state.openModal}
                                        onClose={this.handleModal}
                                        closeAfterTransition
                                        style={{display: 'flex'}}
                                        // BackdropComponent={Backdrop}
                                        BackdropProps={{
                                            timeout: 500,
                                        }}
                                    >
                                        <Fade in={this.state.openModal} style={{
                                            backgroundColor: 'white',
                                            padding: '25px',
                                            margin: 'auto',
                                            overflowY: 'scroll',
                                            width: '75%',
                                            outline: 'none',
                                            maxHeight: '75vh'
                                        }}>
                                            <div>
                                                <h2 id="spring-modal-title">Правила студии</h2>
                                                <p id="spring-modal-description">{this.state.bookingRules}</p>
                                            </div>
                                        </Fade>
                                    </Modal>
                                </div>
                            </div>
                            : <BookingNotAvailable phone={this.state.room.studio_phone}/>
                        }
                    </div>
                }
            </Container>
        )
    }

}


export default Slots